import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-registration-submitted',
  templateUrl: './registration-submitted.component.html',
  styleUrls: []
})
export class RegistrationSubmittedComponent implements OnInit {
  token: string;

  constructor(private activeRoute: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.token = this.activeRoute.snapshot.params["token"];
  }

}
